import { Controller } from "@hotwired/stimulus"

// Loads ActiveHashcash client script and starts mining on the hidden #hashcash field.
// Works with Turbo Drive (re-runs connect on each visit to the contact page).
export default class extends Controller {
  static values = { src: { type: String, default: "/hashcash.js" } }

  connect() {
    if (window.Hashcash) {
      this.startMining()
      return
    }

    const existing = document.getElementById("hashcash-script")
    if (existing) {
      if (existing.dataset.loaded) {
        this.startMining()
      } else {
        existing.addEventListener("load", () => this.startMining(), { once: true })
      }
      return
    }

    const script = document.createElement("script")
    script.id = "hashcash-script"
    script.src = this.srcValue
    script.defer = true
    script.dataset.turboTrack = "reload"
    script.addEventListener("load", () => {
      script.dataset.loaded = "true"
      this.startMining()
    }, { once: true })
    document.head.appendChild(script)
  }

  startMining() {
    const input = document.querySelector("input#hashcash")
    if (!input || input.value) return

    new window.Hashcash(input)
  }
}
